export default () => {
  console.log('INIT FILTERS');
  let filters = document.querySelectorAll('[content-filter]');
  filters.forEach((filter) => {
    console.log(filter);
    filter.addEventListener('change', () => {
      let filterOptions = filter.querySelectorAll('[filter-item] input');
      let filterItems =
        filter.parentNode.querySelectorAll('[filtered-content]');

      filterOptions.forEach((filterOption) => {
        filterOption.addEventListener('change', () => {
          let allUnselected = true;
          filterOptions.forEach((filterOption) => {
            if (filterOption.checked) {
              allUnselected = false;
            }
          });

          filterItems.forEach((filterItem) => {
            if (allUnselected) {
              filterItem.classList.remove('hidden');
            } else {
              let isActive = false;
              filterOptions.forEach((filterOption) => {
                if (
                  filterOption.checked &&
                  filterItem.getAttribute(filterOption.value)
                ) {
                  isActive = true;
                }
              });
              if (isActive) {
                filterItem.classList.remove('hidden');
              } else {
                filterItem.classList.add('hidden');
              }
            }
          });
        });
      });
    });
  });
};
